import { atom } from "jotai";

export const newReferenceMeasurementValueAtom = atom<number | null>(null);
